<!--
  The top bar of the new mentee experience before the first session request:
  the logo, the member's name and Log out. The sidebar comes with the first
  request (Foti, 24 Oct, ruling 8).
-->
<template>
  <nav
    class="flex h-14 items-center border-b border-neutral-100 bg-white px-4 sm:px-7"
    test_id="path-top-bar"
  >
    <InertiaLink href="/dashboard" class="shrink-0">
      <img class="w-36 p-1" src="/growthmentor-logo.svg" alt="GrowthMentor" />
    </InertiaLink>
    <div class="ml-auto flex items-center gap-4 text-sm text-neutral-600">
      <span class="hidden sm:inline">{{ currentUser?.firstName }}</span>
      <button
        type="button"
        class="underline underline-offset-4 hover:text-neutral-900"
        @click="logOut"
      >
        Log out
      </button>
    </div>
  </nav>
</template>

<script setup lang="ts">
import axios from 'axios'
import { useCurrentUser } from '@/shared/composables/useCurrentUser'

const { currentUser } = useCurrentUser()

const logOut = async () => {
  await axios.delete('/users/sign_out')
  window.location.href = '/'
}
</script>
